<template>
    <div class="rounded mx-auto my-2 text-sm bg-primary-lightest text-primary border-primary border p-3" v-if="sponsor">
        <p>🎉 Hurray! You came in via <strong>{{ sponsor.name }}</strong>, we'll offer <strong>{{ sponsor.discount }}</strong> to your subscription {{ sponsor.duration }} whenever you upgrade.</p>
    </div>
</template>

<script setup>
    export default {
        data() {
            return {
                sponsor: null,
            }
        },

        mounted() {
            axios.get('/api/me')
                .then(response => {
                    this.sponsor = response.data.data.sponsor;
                })
                .catch(err => console.error);
        },
    }
</script>